import React from 'react';

const EXAM_TYPE_OPTIONS = [
  { field: 'transvaginalOnly', label: 'Transvaginal Only' },
  { field: 'transvaginal', label: 'Transabdominal & Transvaginal' },
  { field: 'transabdominal', label: 'Transabdominal Only' }
];

// Scanning approach checkboxes shared by the OB worksheets. Only one can be checked at a time.
function ExamTypeSection({ value, onChange }) {
  const handleChange = (field) => {
    if (value[field]) {
      onChange({ ...value, [field]: false });
    } else {
      onChange({
        transabdominal: field === 'transabdominal',
        transvaginal: field === 'transvaginal',
        transvaginalOnly: field === 'transvaginalOnly'
      });
    }
  };

  return (
    <div className="form-section">
      <h3>Exam Type</h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}>
        {EXAM_TYPE_OPTIONS.map(({ field, label }) => (
          <label key={field} style={{ display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={!!value[field]}
              onChange={() => handleChange(field)}
            />
            {label}
          </label>
        ))}
      </div>
    </div>
  );
}

export default ExamTypeSection;
